import ShareUs from '../shareUs/ShareUs';
import styles from './Welcome.module.css';

const Welcome = (props) => {    
  return (
    <div className={styles.classes}>
      <header>
        <h2>Welcome to exambridge.com</h2>
      </header>
      <p>
        A free, convenient, and engaging platform designed to help students
        improve their knowledge and confidently prepare for examinations —
        whether for promotion, certification, or admission into tertiary
        institutions.
        <br />
        <strong>Why Choose Us?</strong>
      </p>
      <ul style={{ lineHeight: "2.4rem" }}>
        <li>
          <strong>Unlimited Access: </strong>Explore a vast collection of
          questions, answers, and detailed explanations across various subjects.
        </li>
        <li>
          <strong>Expert Content: </strong>All materials are curated and
          reviewed by experienced and qualified tutors.
        </li>
        <li>
          <strong>Flexible Use: </strong> Sign in as a registered member to save
          your progress, or continue as a guest for quick access — no
          registration required.
        </li>
        <li>
          <strong>For Everyone: </strong>Whether you're a student, teacher, or
          parent, this platform is built to support your educational journey.
        </li>
      </ul>
      <p>
        <strong>📚 Subjects We Cover</strong>
        <br />
        We're continually working to expand our resources. Currently, the
        following subjects are available:
      </p>
      <ol className={styles.subjectGrid}>
        <li>Accounting (including Financial Accounting)</li>
        <li>Agricultural Science</li>
        <li>Biology</li>
        <li>Chemistry</li>
        <li>Commerce</li>
        <li>Economics</li>
        <li>English Language</li>
        <li>Food and Nutrition</li>
        <li>Further Mathematics</li>
        <li>Geography</li>
        <li>Literature in English</li>
        <li>Mathematics</li>
        <li>Physics</li>
      </ol>
      <p>
        Start exploring now and take your learning to the next level — it's all
        free!
      </p>
      <div style={{ margin: "1rem 0 2rem 0", textAlign: "center" }}>
        <p>
          <strong>Ready to begin?</strong>
          <button
            style={{
              margin: "0 0 0 1rem",
              padding: "0.25rem 1.75rem",
              background: "#111",
            }}
            onClick={props.onDisplayRobotest}
          >
            Next
          </button>
        </p>
      </div>
      <ShareUs />
      <div
        style={{
          marginTop: "2rem",
          marginBottom: "1rem",
          whiteSpace: "nowrap",
          fontSize: "0.9rem",
          textAlign: "center",
        }}
      >
        <a
          style={{ margin: "0 0.5rem" }}
          href="legal/privacy-policy.html"
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy Policy
        </a>
        {" | "}
        <a
          style={{ margin: "0 0.5rem" }}
          href="legal/terms-of-service.html"
          target="_blank"
          rel="noopener noreferrer"
        >
          Terms of Service
        </a>
        {" | "}
        <a
          style={{ margin: "0 0.5rem" }}
          href="legal/user-data-deletion.html"
          target="_blank"
          rel="noopener noreferrer"
        >
          Data Deletion
        </a>
        {" | "}
        <a
          style={{ margin: "0 0.5rem" }}
          href="legal/contact-support.html"
          target="_blank"
          rel="noopener noreferrer"
        >
          Contact / Support
        </a>
      </div>
    </div>
  );
};

export default Welcome;